import React from 'react';
import { withStyles, CircularProgress } from './../../../../../assets/theme/default';
import { TextField, Autocomplete, Checkbox } from './../../../../../assets/theme/input';
import { CheckBoxOutlineBlankIcon, CheckBoxIcon } from './../../../../../assets/theme/icon';
import { MercadoPagoService } from './../../../../../services';

import API from './../../../../../config/api';

const styles = theme => ({
  paper: {
    background: theme.palette.background.default,
    border: `1px solid ${ theme.palette.grey.main }`
  },
  label: {
    fontWeight: 500,
    position: 'relative',
    transition: 'none',
    transform: 'none',
    marginBottom: theme.spacing(0.5),
    fontSize: theme.typography.fontSize
  },
  inputRoot: {
    marginTop: `0 !important`,
    border: `1px solid ${ theme.palette.grey.main }`,
    background: '#fbfbfb',
    padding: `${ theme.spacing(1) }px ${ theme.spacing(5) }px ${ theme.spacing(1) }px ${ theme.spacing(1) }px !important`,
    borderRadius: `3px !important`,
    '&:before': {
      display: 'none !important'
    },
    '&:after': {
      display: 'none !important'
    }
  },
  inputInput: {
    padding: '0 !important'
  },
  inputEndAdornment: {
    right: theme.spacing(1)
  }
});

class PaymentMethodsAutocomplete extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: true,
      entities: [],
      selected: []
    };
  }

  /**
  * @Event
  * @Description: Is invoked immediately after a component is mounted.
  */
  componentDidMount(){
    this._All();
  }

  /*
  ** @Service
  ** @Description: List all permissions
  */

  _All = () => {

    MercadoPagoService.paymentMethods().then((response) => {

      this.setState({
        loading: false,
        entities: response.payment_methods
      });

      // @Function
      // @Description: Exclude payments
      this.handleExcludePayments();

    });

  }

  /*
  ** @Event
  ** @Description: Filter exclude payments
  */

  handleExcludePayments = () => {

    if (API.mercadopago.preference.excluded_payments) {
      if (API.mercadopago.preference.excluded_payments.length > 0) {

        API.mercadopago.preference.excluded_payments.forEach((id, index) => {

          let payment = this.state.entities.find( p => p.id === id);

          if(payment){

            // @State
            // @Description
            this.setState({ selected: [...this.state.selected, payment] });

          }

        });

        // @Props
        // @Description: Send value to parent
        this.props.onSelect(this.state.selected);

      }
    }

  }

  /*
  ** @Event
  ** @Description: on select category
  */

  handleSelect = (listOfPaymentMethods) => {
    this.setState({ selected: listOfPaymentMethods });
  }

  /*
  ** @Event
  ** @Description: on change selection
  */

  handleOnChange = (value) => {

    // @If
    // @Description: If value !== null select category
    if (value) {

      this.handleSelect(value);

    }else{

      // @Store
      // @Description: Set store selected null
      this.setState({ selected: [] });

    }

    // @Props
    // @Description: Send value to parent
    this.props.onSelect(value);

  }

  /*
  ** @Render
  */

  render() {

    const { classes, label } = this.props;
    const { loading, entities, selected } = this.state;

    const uncheckediIcon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon    = <CheckBoxIcon fontSize="small" />;

    return(
      <Autocomplete
        loading={ loading }
        loadingText="Cargando..."
        classes={{
          paper: classes.paper,
          inputRoot: classes.inputRoot,
          input: classes.inputInput,
          endAdornment: classes.inputEndAdornment
        }}
        value={ selected }
        size="small"
        multiple
        disableCloseOnSelect
        noOptionsText="No se encontraron resultados"
        options={ entities }
        onChange={(event, newInputValue) => {
          this.handleOnChange(newInputValue)
        }}
        getOptionLabel={
          (option) => option.name
        }
        getOptionSelected={(option, value) => {
           return (option.id === value.id);
        }}
        renderOption={(option, { selected }) => (
          <React.Fragment>
            <Checkbox
              icon={ uncheckediIcon }
              checkedIcon={ checkedIcon }
              style={{ marginRight: 8 }}
              checked={ selected }
              size="small"
            />
            { option.name }
          </React.Fragment>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={ label ? label : "Medios de pago" }
            InputLabelProps={{
              shrink: true,
              classes: {
                root: classes.label
              }
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    )
  }

}

export default withStyles(styles)(PaymentMethodsAutocomplete);
